module.exports = __webpack_public_path__ + "img/7b_Cameras.192f24ca.png";